import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Disc = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Disc' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 Z M12,14 C13.1045695,14 14,13.1045695 14,12 C14,10.8954305 13.1045695,10 12,10 C10.8954305,10 10,10.8954305 10,12 C10,13.1045695 10.8954305,14 12,14 Z' />
  </StyledIcon>
);
